export const EncryptString = (message) => {
  if (message) {
    return btoa(message).toString();
  }
  return "";
};
export const DecryptString = (message) => {
  if (message) {
    return atob(message).toString();;
  }
  return "";
};

export const EncryptJSON = (message) => {
  if (message) {
    return btoa(JSON.stringify(message)).toString();
  }
  return '';
};
export const DecryptJSON = (message) => {
  if (message) {
    var bytes = atob(message);
    return JSON.parse(bytes);
  }
  return '';
};
